import { createLoadableDictionaryReducer } from "../loadableStore/loadableReducer";

const data = createLoadableDictionaryReducer<string>("externalContent");

export const externalContentReducer = data.reducer;
export const externalContentActions = data.actions;
